import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeSvg',
  standalone: false,
})
export class SafeSvgPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: unknown): SafeHtml {
    if (typeof value === 'string') {
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }
    return '';
  }

}
